import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import { useParams, Link } from "react-router-dom";
import axios from "axios";
import BlogSide from "./BlogSide";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faCalendar,
  faUser,
  faChevronRight,
} from "@fortawesome/free-solid-svg-icons";
import blogBg from "../../assets/about/blog.jpeg";
import BASE_URL from "../../config/config";
const BlogDetail = () => {
  const { slug } = useParams();
  const [blog, setBlog] = useState(null);
  const imageBaseURL = `${BASE_URL}/employees/view/`;

  useEffect(() => {
    AOS.init({ duration: 1000, once: true });

    axios
      .get(`${BASE_URL}/blogs/list`)
      .then((res) => {
        if (res.data.success) {
          const found = res.data.data.find((item) => {
            const blogSlug = item.title.replace(/\s+/g, "-").toLowerCase();
            return blogSlug === slug;
          });
          setBlog(found);
        }
      })
      .catch((err) => console.error(err));
  }, [slug]);

  if (!blog) {
    return (
      <div className="py-20 text-center text-gray-600 text-lg">
        Loading blog details...
      </div>
    );
  }

  const imageUrl = `${imageBaseURL}${blog.image?.split("/").pop()}`;

  return (
    <div>
      {/* Hero */}
      <div
        className="relative text-left py-20 bg-cover bg-center bg-no-repeat"
        style={{ backgroundImage: `url(${blogBg})` }}
      >
        <div className="absolute inset-0 bg-black opacity-30"></div>
        <div className="flex mx-auto items-start justify-start">
          <div className="relative max-w-3xl px-6 py-2">
            <div className="relative z-10 text-white drop-shadow-xl flex flex-col items-start justify-center h-full">
              <h1 className="md:text-4xl text-2xl font-semibold mb-4">
                Our Blogs
              </h1>
              <div className="flex items-center space-x-2 text-sm md:text-base">
                <Link
                  to="/"
                  className="text-white hover:text-main1 font-semibold"
                >
                  Home
                </Link>
                <FontAwesomeIcon icon={faChevronRight} className="text-xs" />
                <Link to="/blog" className="text-gray-300 hover:text-main1">
                  Blogs
                </Link>
                <FontAwesomeIcon icon={faChevronRight} className="text-xs" />
                <span className="text-gray-300 hover:text-main1">
                  Blog Detail
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Blog Content */}
      <div className="md:py-5 py-1">
        <h2 className="text-xl px-2 md:px-0 md:text-3xl font-bold text-center mt-4 mb-2 text-gray-600">
          {blog.title}
        </h2>
        <div className="md:w-40 w-20 h-1 bg-main mx-auto md:mb-3 mb-1 rounded-full" />
        {/* <p className="text-center text-gray-700 px-4 md:px-20 lg:px-40">
          {blog.subtitle}`
        </p> */}

        <div className="md:px-5 px-4 sm:px-6 lg:px-8 grid grid-cols-1 lg:grid-cols-[2fr_1fr] gap-3 md:gap-8">
          <div className="container mx-auto px-4 py-8">
            <div className="grid grid-cols-1 gap-8">
              <div className="w-full mx-auto">
                <img
                  src={imageUrl}
                  alt={blog.alt || blog.title}
                  className="w-full h-full rounded-lg object-cover"
                />
                <div className="text-gray-600 mt-2 text-xs flex flex-wrap gap-x-6 gap-y-2 items-center mb-2">
                  <span className="flex items-center gap-1">
                    <FontAwesomeIcon icon={faUser} />
                    <span>{blog.author}</span>
                  </span>
                  <span className="flex items-center gap-1">
                    <FontAwesomeIcon icon={faCalendar} />
                    <span>{blog.date}</span>
                  </span>
                </div>
              </div>

              {/* Blog Description */}
              <div className="space-y-2 md:text-base text-sm text-justify">
                <p className="text-gray-600">{blog.description}</p>
                {Array.isArray(blog.listings) &&
                  blog.listings.map((item, idx) => (
                    <div key={idx} className="my-3">
                      <h3 className="text-xl font-semibold text-main mb-1">
                        {item.heading}
                      </h3>
                      <div
                        className="text-gray-700"
                        dangerouslySetInnerHTML={{ __html: item.content }}
                      />
                    </div>
                  ))}
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="hidden md:block self-start p-3 h-fit">
            <BlogSide />
          </div>
        </div>
      </div>
    </div>
  );
};

export default BlogDetail;
